import { useEffect, useState } from 'react'

export const useIsPwaInstalled = () => {
  const [isInstalled, setIsInstalled] = useState(false)

  useEffect(() => {
    const checkPwaInstalled = () => {
      const isStandalone =
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone
      setIsInstalled(isStandalone)
    }

    window.addEventListener('load', checkPwaInstalled)
    return () => window.removeEventListener('load', checkPwaInstalled)
  }, [])

  return isInstalled
}
